module.exports = __webpack_public_path__ + "images/file_icons_v2/gam-b83db1acf29a0649808ad454a91130a7.svg";